import { Flex, Text, Image, Box, useBreakpointValue } from "@chakra-ui/react";
import React from "react";
import sconexLogo from "../../assets/img/sconex.jpeg";

export default function Footer(props) {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const currentYear = new Date().getFullYear();

  return (
    <Box
      as="footer"
      bg="white"
      borderTop="1px solid"
      borderColor="gray.200"
      mt="auto"
    >
      <Flex
        alignItems="center"
        justifyContent={{ base: "center", md: "flex-start" }}
        flexDirection={{ base: "column", md: "row" }}
        px={{ base: "20px", md: "40px" }}
        py={{ base: "24px", md: "20px" }}
        gap={{ base: "16px", md: "12px" }}
        textAlign={{ base: "center", md: "left" }}
      >
        {/* Copyright Text */}
        <Text
          color="gray.700"
          fontSize={{ base: "sm", md: "md" }}
          fontWeight="500"
          order={{ base: 1, md: 1 }}
        >
          Copyright © {currentYear}
        </Text>

        {/* Logo with subtle animation */}
        <Box
          order={{ base: 3, md: 2 }}
          mt={{ base: "8px", md: "0" }}
        >
          <Image
            src={sconexLogo}
            alt="SCONEX SOFT Logo"
            height={{ base: "20px", md: "24px" }}
            width="auto"
            transition="all 0.2s ease-in-out"
            _hover={{
              transform: "scale(1.05)",
              opacity: 0.9
            }}
            cursor="pointer"
          />
        </Box>

        {/* Confidential Badge */}
        <Box
          order={{ base: 2, md: 3 }}
          display="flex"
          alignItems="center"
          gap="8px"
        >
          <Box
            w="6px"
            h="6px"
            bg="red.400"
            borderRadius="full"
            display={{ base: "none", sm: "block" }}
          />
          <Text
            color="gray.600"
            fontSize={{ base: "sm", md: "md" }}
            fontWeight="500"
            px="12px"
            py="4px"
            bg="gray.50"
            borderRadius="full"
            border="1px solid"
            borderColor="gray.200"
          >
            Confidential
          </Text>
        </Box>

        {/* Additional Info - Only on desktop */}
        <Text
          color="gray.500"
          fontSize="sm"
          display={{ base: "none", lg: "block" }}
          order={4}
          ml={{ md: "auto" }}
        >
          All rights reserved
        </Text>
      </Flex>

      {/* Mobile-only additional info */}
      <Text
        color="gray.500"
        fontSize="xs"
        textAlign="center"
        pb="16px"
        display={{ base: "block", lg: "none" }}
      >
        All rights reserved
      </Text>
    </Box>
  );
}